/*global Flatpickr*/
angular.module('mtic.components.timePicker',[]).
directive('flatTimePicker', function ($log) {return {
    require: 'ngModel',
    restrict: 'A',
    scope: {
        options: '='
    },
    link: function (scope, element, attrs, ngModel) {
        var timePicker;
        var init = function(){
            var options = _.extend({
                // mode: 'range',
                dateFormat: 'Y-m-d',
                defaultDate: 
                // [
                    // moment().format('YYYY-MM-DD'),
                    moment().add(7,'days').format('YYYY-MM-DD'),
                // ],
                enableTime: false,
            }, scope.options || {});
            timePicker = new Flatpickr(element[0], options)
        }
        element.on('$destroy',function(){
            if(timePicker){
                timePicker.destroy();
                timePicker = null;
            }
        });
        init();
        scope.$watch('options', function(val){
            if(val){
                init()
            }
        })
    }
}})